(()=>{
  const currentScript=document.currentScript;
  const pageType=currentScript?.dataset.adwoaPageType||'';
  const interfaceSrc=currentScript?.dataset.adwoaInterfaceSrc||'';
  if(pageType==='password'||pageType==='index'||!interfaceSrc)return;

  const SEARCH_WIRE_VERSION='dynamic-width-20260918';
  const BASE_SEARCH_CH=8;
  const norm=value=>String(value||'').replace(/\s+/g,' ').trim().toUpperCase();
  const make=(tag,cls,text)=>{const el=document.createElement(tag);if(cls)el.className=cls;if(text!=null)el.textContent=text;return el;};

  const styles=()=>{
    const existing=document.getElementById('AdwoaHeaderFixes');
    if(existing)existing.remove();
    const style=make('style');
    style.id='AdwoaHeaderFixes';
    style.textContent=`
      [data-adwoa-shop-interface] .adwoa-shop-search,
      [data-adwoa-shop-interface] .adwoa-shop-search__trigger,
      [data-adwoa-shop-interface] .adwoa-shop-search__input{
        font-family:var(--adwoa-header-font-family,inherit)!important;
        font-size:var(--adwoa-header-font-size,inherit)!important;
        font-weight:var(--adwoa-header-font-weight,inherit)!important;
        line-height:var(--adwoa-header-line-height,inherit)!important;
        letter-spacing:var(--adwoa-header-letter-spacing,inherit)!important;
        text-transform:uppercase!important;
      }
      .adwoa-shop-search{
        position:relative!important;
        display:inline-block!important;
        white-space:nowrap!important;
        text-align:right!important;
        overflow:visible!important;
        width:var(--adwoa-search-width,8ch)!important;
        min-width:var(--adwoa-search-width,8ch)!important;
        max-width:none!important;
        margin-left:var(--adwoa-search-offset,0ch)!important;
        flex:0 0 auto!important;
        vertical-align:baseline!important;
      }
      .adwoa-shop-search__trigger{
        display:inline-block!important;
        width:100%!important;
        min-width:0!important;
        background:transparent!important;
        border:0!important;
        color:inherit!important;
        padding:0!important;
        margin:0!important;
        cursor:text!important;
        appearance:none!important;
        -webkit-appearance:none!important;
        text-align:right!important;
        white-space:nowrap!important;
      }
      .adwoa-shop-search__form{
        display:none!important;
        align-items:baseline!important;
        justify-content:flex-end!important;
        margin:0!important;
        padding:0!important;
        text-align:right!important;
        width:100%!important;
        min-width:0!important;
        max-width:none!important;
        overflow:visible!important;
        white-space:nowrap!important;
      }
      .adwoa-shop-search.is-open .adwoa-shop-search__trigger{display:none!important}
      .adwoa-shop-search.is-open .adwoa-shop-search__form{display:inline-flex!important}
      .adwoa-shop-search__input{
        width:100%!important;
        min-width:0!important;
        max-width:none!important;
        box-sizing:border-box!important;
        padding:0!important;
        margin:0!important;
        border:0!important;
        border-radius:0!important;
        background:transparent!important;
        color:#000!important;
        box-shadow:none!important;
        outline:0!important;
        appearance:none!important;
        -webkit-appearance:none!important;
        text-align:right!important;
        direction:ltr!important;
        unicode-bidi:plaintext!important;
        overflow:visible!important;
        white-space:nowrap!important;
      }
      .adwoa-shop-search__input::placeholder{color:#000!important;opacity:.5!important;text-align:right!important}
      .adwoa-shop-search__input::-webkit-search-decoration,
      .adwoa-shop-search__input::-webkit-search-cancel-button,
      .adwoa-shop-search__input::-webkit-search-results-button,
      .adwoa-shop-search__input::-webkit-search-results-decoration{display:none!important}
      @media screen and (min-width:990px){
        [data-adwoa-shop-interface] .adwoa-shop-interface__utilities{align-items:flex-start!important}
        [data-adwoa-shop-interface] a,
        [data-adwoa-shop-interface] button,
        [data-adwoa-shop-interface] span,
        [data-adwoa-shop-interface] input{
          font-size:14px!important;line-height:1!important;letter-spacing:.04em!important;font-weight:700!important;
        }
      }
    `;
    document.head.appendChild(style);
  };

  const findTopItem=(ui,label)=>Array.from(ui.querySelectorAll('a,button')).find(el=>norm(el.textContent)===label);

  const syncSearchFont=(ui,root)=>{
    const ref=findTopItem(ui,'SHOWROOM')||Array.from(ui.querySelectorAll('a,button')).find(el=>norm(el.textContent).startsWith('BAG'));
    if(!ref||!root)return;
    const cs=getComputedStyle(ref);
    root.style.setProperty('--adwoa-header-font-family',cs.fontFamily);
    root.style.setProperty('--adwoa-header-font-size',cs.fontSize);
    root.style.setProperty('--adwoa-header-font-weight',cs.fontWeight);
    root.style.setProperty('--adwoa-header-line-height',cs.lineHeight);
    root.style.setProperty('--adwoa-header-letter-spacing',cs.letterSpacing);
    root.style.fontFamily=cs.fontFamily;
    root.style.fontSize=cs.fontSize;
    root.style.fontWeight=cs.fontWeight;
    root.style.lineHeight=cs.lineHeight;
    root.style.letterSpacing=cs.letterSpacing;
    root.querySelectorAll('button,input').forEach(el=>{
      el.style.fontFamily=cs.fontFamily;
      el.style.fontSize=cs.fontSize;
      el.style.fontWeight=cs.fontWeight;
      el.style.lineHeight=cs.lineHeight;
      el.style.letterSpacing=cs.letterSpacing;
    });
  };

  const moveSearch=(ui,root)=>{
    const showroom=findTopItem(ui,'SHOWROOM');
    if(showroom&&showroom.parentElement&&root.nextElementSibling!==showroom){
      showroom.parentElement.insertBefore(root,showroom);
    }
    syncSearchFont(ui,root);
    requestAnimationFrame(()=>syncSearchFont(ui,root));
    setTimeout(()=>syncSearchFont(ui,root),250);
    setTimeout(()=>syncSearchFont(ui,root),1000);
  };

  const buildSearch=()=>{
    const root=make('div','adwoa-shop-search');
    root.setAttribute('data-adwoa-search','');
    root.style.setProperty('--adwoa-search-width',BASE_SEARCH_CH+'ch');
    root.style.setProperty('--adwoa-search-offset','0ch');
    const trigger=make('button','adwoa-shop-search__trigger','SEARCH');
    trigger.type='button';
    trigger.setAttribute('aria-expanded','false');
    const form=make('form','adwoa-shop-search__form');
    form.setAttribute('role','search');
    form.autocomplete='off';
    const input=make('input','adwoa-shop-search__input');
    input.type='search';
    input.name='q';
    input.placeholder='SEARCH';
    input.autocomplete='off';
    input.autocorrect='off';
    input.autocapitalize='off';
    input.spellcheck=false;
    input.dir='ltr';
    input.setAttribute('aria-label','Search');
    form.appendChild(input);
    root.append(trigger,form);
    return root;
  };

  const wireSearch=(ui,root)=>{
    if(root.dataset.adwoaSearchWired==='true'&&root.dataset.adwoaSearchVersion!==SEARCH_WIRE_VERSION){
      const oldInput=root.querySelector('.adwoa-shop-search__input');
      const replacement=buildSearch();
      const newInput=replacement.querySelector('.adwoa-shop-search__input');
      if(oldInput?.value)newInput.value=oldInput.value;
      root.replaceWith(replacement);
      wireSearch(ui,replacement);
      return;
    }

    if(root.dataset.adwoaSearchWired==='true'){
      moveSearch(ui,root);
      return;
    }
    root.dataset.adwoaSearchWired='true';
    root.dataset.adwoaSearchVersion=SEARCH_WIRE_VERSION;

    const trigger=root.querySelector('.adwoa-shop-search__trigger');
    const form=root.querySelector('.adwoa-shop-search__form');
    const input=root.querySelector('.adwoa-shop-search__input');
    if(!trigger||!form||!input)return;

    const maxChars=()=>{
      if(window.innerWidth>=1200)return 42;
      if(window.innerWidth>=990)return 34;
      return 22;
    };

    const setWidth=widthCh=>{
      const width=Math.max(BASE_SEARCH_CH,Math.min(maxChars(),widthCh));
      root.style.setProperty('--adwoa-search-width',width+'ch');
      root.style.setProperty('--adwoa-search-offset',(BASE_SEARCH_CH-width)+'ch');
      form.style.width='100%';
      input.style.width='100%';
    };

    const collapseWidth=()=>setWidth(BASE_SEARCH_CH);

    const syncWidth=()=>{
      const text=input.value||input.placeholder||'SEARCH';
      const length=Array.from(text).length;
      setWidth(length+2);
    };

    const pinCaret=()=>{
      const end=input.value.length;
      try{input.setSelectionRange(end,end);}catch(e){}
      try{input.scrollLeft=input.scrollWidth;}catch(e){}
    };

    const open=()=>{
      root.classList.add('is-open');
      trigger.setAttribute('aria-expanded','true');
      syncSearchFont(ui,root);
      syncWidth();
      setTimeout(()=>{
        input.focus();
        pinCaret();
      },0);
    };

    const closeIfEmpty=()=>{
      if(input.value.trim())return;
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded','false');
      collapseWidth();
    };

    const reset=()=>{
      input.value='';
      root.classList.remove('is-open');
      trigger.setAttribute('aria-expanded','false');
      collapseWidth();
    };

    trigger.addEventListener('click',event=>{event.preventDefault();open();});
    form.addEventListener('submit',event=>{
      event.preventDefault();
      const query=input.value.trim();
      if(query)window.location.href='/search?q='+encodeURIComponent(query);
      else input.focus();
    });
    input.addEventListener('input',()=>{syncWidth();pinCaret();});
    input.addEventListener('keydown',event=>{
      if(event.key==='Escape'){
        event.preventDefault();
        reset();
      }
    });
    input.addEventListener('blur',closeIfEmpty);
    window.addEventListener('resize',syncWidth);
    document.addEventListener('click',event=>{
      if(!root.contains(event.target))closeIfEmpty();
    });
    collapseWidth();
    moveSearch(ui,root);
  };

  const patchSearch=ui=>{
    styles();

    const existingRoot=ui.querySelector('[data-adwoa-search]');
    if(existingRoot){
      wireSearch(ui,existingRoot);
      return;
    }

    const old=Array.from(ui.querySelectorAll('a[href],button')).find(el=>{
      const href=el.getAttribute?.('href')||'';
      return href==='/search'||href.startsWith('/search?')||norm(el.textContent)==='SEARCH';
    });

    const root=buildSearch();

    if(old){
      old.replaceWith(root);
    }else{
      const showroom=findTopItem(ui,'SHOWROOM');
      if(showroom?.parentElement)showroom.parentElement.insertBefore(root,showroom);
      else ui.appendChild(root);
    }

    wireSearch(ui,root);
  };

  const waitForInterface=()=>{
    let tries=0;
    (function tick(){
      const ui=document.querySelector('[data-adwoa-shop-interface]');
      if(ui){patchSearch(ui);return;}
      if(tries++<160)setTimeout(tick,50);
    })();
  };

  const load=()=>{
    document.querySelectorAll('[data-adwoa-shop-interface]').forEach(el=>el.remove());
    document.documentElement.classList.remove('adwoa-shop-interface-active');

    const existing=document.querySelector('script[data-adwoa-global-interface-loader]');
    if(existing){
      existing.addEventListener('load',waitForInterface,{once:true});
      waitForInterface();
      return;
    }

    const script=document.createElement('script');
    script.src=interfaceSrc;
    script.dataset.adwoaGlobalInterfaceLoader='true';
    script.dataset.adwoaPageType=pageType;
    script.addEventListener('load',waitForInterface,{once:true});
    document.head.appendChild(script);
    waitForInterface();
  };

  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',load,{once:true});
  else load();
})();
